import type { PaginatedListResponseApi } from '@ingenico/api-sdk-device-management-public';
import type { AssetResourceReadV2ApiFront } from './asset.model';

export enum ApplicationResourceStatus {
  PUBLISHED = 'PUBLISHED',
  DEPRECATED = 'DEPRECATED',
}

interface ApplicationResourceProviderLocation {
  readonly address: string;
  readonly city: string;
  readonly zipCode: string;
  readonly state: string;
  readonly country: string;
}

export interface ApplicationResourceProvider {
  readonly name: string;
  readonly location: ApplicationResourceProviderLocation;
}

export interface ApplicationResourceFront {
  readonly id: string;
  readonly name: string;
  readonly shortDescription?: string;
  readonly longDescription?: string;
  readonly status: ApplicationResourceStatus;
  readonly creationDate?: Date;
  readonly provider?: ApplicationResourceProvider;
  readonly compatibleDeviceFamilyNames: string[];
  readonly applicationVersionIds: string[];
  readonly assets: AssetResourceReadV2ApiFront[];
}

export interface PaginatedApplicationList extends PaginatedListResponseApi {
  readonly data: ApplicationResourceFront[];
}
